
<div [ngxSummernoteView]="value"></div>
	
